import { toast } from "sonner";

export const DEFAULT_TOAST_OPTIONS = {
  cancel: {
    label: "Close",
    onClick: () => {
      toast.dismiss();
    },
  },
  duration: 2000,
};
